const resolveColor = ({
  isHelp,
  theme
}) => {
  return isHelp ? theme.orbit.paletteBlueNormal : theme.orbit.paletteRedNormal;
};
export default resolveColor;